import { render, staticRenderFns } from "./CleanHeader.vue?vue&type=template&id=241f974b&"
import script from "./CleanHeader.vue?vue&type=script&lang=ts&"
export * from "./CleanHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CleanHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports